import Core from "./core"
import Address from "./address"
import Pos from "./pos"
import Offer from "./Offer"
import AdditionalServices from "./AdditionalService"

const Store = {
  namespaced: true,
  modules: {
    Core,
    Address,
    Pos,
    Offer,
    AdditionalServices
  }
}

export default Store
